export enum PaymentMethodTypes {
    CARD   = 'card',
    QRCPAY = 'qrcpay',
}

export type PaymentMethod = {
    type: PaymentMethodTypes
    selected: boolean
    disabled: false
}
